export const STATUS_NOT_AVAILABLE = "not_available";
export const STATUS_GLOBAL_DAY_OFF = "global_day_off";
export const STATUS_NON_WORKING_DAYS = "non_working_days";
export const STATUS_USER_DAY_OFF = "user_day_off";
